
<div class="pg-page-wrapper">
  <router-view v-if="isMobile"></router-view>
  <pc v-else></pc>
</div>
